import { selectIsBulkPage } from '@reducers/app/selectors';
import { selectProspectContacts } from '@reducers/company/selectors';
import { selectHasDncPhone, selectHasOnlyDncPhones } from '@reducers/contacts/selectors';
import { store } from '@reducers/store';
import { reaction } from 'mobx';
import { applySnapshot, getSnapshot } from 'mobx-state-tree';
import { reportDncContactViewedClientEvent } from '../../../utils/BIEvents/dnc-event';
import { SEARCH_STATUS } from '../../../utils/constants';
const Actions = self => {
    let initialState;
    const onSearchStatusChange = () => {
        const isSearchResolved = self.searchStatus === SEARCH_STATUS.RESOLVED;
        const reduxContacts = selectProspectContacts(store.getState());
        const contactsWithSomeDncPhonesCount = reduxContacts.filter(contact => selectHasDncPhone(contact)).length;
        if (isSearchResolved && contactsWithSomeDncPhonesCount) {
            reportDncContactViewedClientEvent({
                uniqueSearchId: selectIsBulkPage(store.getState()) ? self.uniqueSearchId : '',
                subPlatform: store.getState().settings.platform,
                pageUrl: store.getState().app.url,
                numOfContactsWithDncPhone: contactsWithSomeDncPhonesCount,
                numOfContactsWithOnlyDncPhones: reduxContacts.filter(contact => selectHasOnlyDncPhones(contact)).length,
                isBulkSearch: true,
            });
        }
    };
    const resetState = state => {
        applySnapshot(self, state);
    };
    return {
        afterCreate: () => {
            initialState = getSnapshot(self);
            reaction(() => self.searchStatus, onSearchStatusChange);
        },
        setEmployeeFreeText: value => {
            self.employeeFreeText = value;
        },
        setProspectingActiveTab: value => {
            self.prospectingActiveTab = value;
        },
        setSearchActiveTab: value => {
            self.searchActiveTab = value;
        },
        init: (partialSnapshot = {}) => {
            const { searchActiveTab } = self;
            resetState(Object.assign(Object.assign(Object.assign({}, initialState), partialSnapshot), { searchActiveTab }));
        },
        setSearchMetadataResult: result => {
            const { sessionId = '', requestId = '', uniqueSearchId = '' } = result;
            self.sessionId = sessionId;
            self.requestId = requestId;
            self.uniqueSearchId = uniqueSearchId;
        },
        setSearchStatus: status => {
            self.searchStatus = status;
        },
        setFirstSearch: setter => {
            self.firstSearch = setter;
        },
        setShowEmployeesCounterBadge: setter => {
            self.showEmployeesCounterBadge = setter;
        },
        setUniqueSearchId: uniqueSearchId => {
            self.uniqueSearchId = uniqueSearchId;
        },
        setCreditSplitButtonType: type => {
            self.creditSplitClickedButtonType = type;
        },
        setSearchQuery: searchQuery => {
            self.searchQuery = searchQuery;
        },
        setShouldResearchEmployees: shouldRefresh => {
            self.shouldResearchEmployees = shouldRefresh;
        },
    };
};
export default Actions;
